import { type FC } from 'react';
import { User } from '../../../../../../Context/UserContext';
import styles from './AttributeAvailability.module.scss?module';
import { formatDate } from '../../../../../../Helper/formatter';
import { FilterState } from '../../../../../../Context/ProductsFilterContext';
import OverflowedTextTooltip from '../../../../../OverflowedTextTooltip/OverflowedTextTooltip';
import clsx from 'clsx';

type AttributeAvailabilityPropsT = {
  user: User;
  attributeName;
  attributeEta?: any;
  hasStock: boolean;
  view: FilterState['view'];
  allowBackorder?: boolean;
};

const AttributeAvailability: FC<AttributeAvailabilityPropsT> = ({
  user,
  attributeName,
  attributeEta,
  hasStock,
  view,
  allowBackorder = false,
}) => {
  return (
    <div className={styles.AttributeAvailability}>
      {user?.id && !allowBackorder && (
        <span
          className={clsx(styles.Dot, hasStock ? 'bg-success' : 'bg-danger')}
        />
      )}
      <div className={styles.Content}>
        {view === 'table' ? (
          <OverflowedTextTooltip
            text={attributeName}
            className={styles.OverflowedTextTooltip}
          />
        ) : (
          <div className={styles.AttributeName}>{attributeName}</div>
        )}
        {attributeEta ? (
          <div className={styles.ETA}>{`ETA: ${formatDate(attributeEta)}`}</div>
        ) : null}
      </div>
    </div>
  );
};

export default AttributeAvailability;
